import { StrictMode } from 'react';

import { RouterProvider, createRouter } from '@tanstack/react-router';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/fonts/proxima-nova/stylesheet.css';
import * as Sentry from '@sentry/react';
import { ErrorBoundary } from '@sentry/react';

// Import the generated route tree
import { routeTree } from './routeTree.gen';

import { initializeSentry } from './configs/sentry'

// Initialize Sentry
initializeSentry()

// Add global unhandled promise rejection handler
window.addEventListener('unhandledrejection', event => {
  Sentry.captureException(event.reason);
});

// Add global error handler for console errors
window.addEventListener('error', event => {
  Sentry.captureException(event.error);
});

// Make Sentry available globally for testing (development only)
if (process.env.NODE_ENV === 'development') {
  (window as any).Sentry = Sentry;
}

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <ErrorBoundary fallback={() => <div>Something went wrong</div>}>
      <StrictMode>
        <RouterProvider router={router} />
      </StrictMode>
      ,
    </ErrorBoundary>,
  );
}
